import {Button, Col, Row} from "antd";
import ChoosePackage from "./choosePackage";

const SubscriptionPackage = () => {

    return (
        <div className={"text-center bg-white h-full px-[125px] py-[24px]"}>
            <h2 className={"text-4xl"}> Nâng cấp để có thêm tính năng </h2>
            <h2 className={"text-3xl"} style={{color: "#344054"}}> Thêm tính năng, thêm nhiều lợi ích </h2>
            <div className={"px-[299px] text-xl"}>
                Bằng việc nâng cấp, bạn đồng ý với
                <a className={'underline'}> Điều khoản dịch vụ của Dogoo . </a> Lưu ý:
                <a className={"underline"}> Chính sách quyền riêng tư của Dogoo </a> mô tả cách xử lý dữ liệu trong dịch
                vụ này.
            </div>

            <Row className={"mt-6 mb-3"}>
                <Col span={8}/>
                <Col span={5}>
                    <Row className={"p-1.5"}
                         style={{
                             backgroundColor: "#F9FAFB",
                             border: "1px solid #F2F4F7",
                             borderRadius: 8
                         }}
                    >
                        <Col span={12}>
                            <Button className={"py-2.5 px-3.5"}
                                    style={{
                                        border: 0,
                                        boxShadow: "0px 1px 3px 0px #1018281A"
                                    }}
                            >
                                Hàng tháng
                            </Button>
                        </Col>
                        <Col span={12}>
                            <Button className={"py-2.5 px-3.5"}
                                    style={{
                                        border: 0,
                                        boxShadow: "0px 1px 3px 0px #1018281A",
                                        backgroundColor: "#F9FAFB",
                                    }}
                            >
                                Hằng năm
                            </Button>
                        </Col>
                    </Row>
                </Col>
                <Col span={8}/>
            </Row>

            <ChoosePackage/>
        </div>
    )
}
export default SubscriptionPackage
